import { useState, useEffect } from 'react'
import { getProductsFromQuery } from '@api/nosto'
import { slugify } from '@utils/utils'
import OrganicTag from '@icons/OrganicTag.jsx'
import QuickBuyBagIcon from '@icons/QuickBuyBagIcon.jsx'
import QuickBuyNosto from '@components/Collection/QuickBuyNosto.jsx'
import useHover from '@hooks/useHover'
import parse from 'html-react-parser'
const productUrlBase = '/products/'

const NostoRecommendationProduct = ({ product }) => {
    const [quickBuyActive, setQuickBuyActive] = useState(false)
    const [ref, isHovered] = useHover()

    let productUrl = product?.productUrl?.split('/products/')[1] || product?.productHandle
    productUrl = productUrl?.split('_')[0]

    let productVariants = product?.skus
    let firstVariantWithInventory = productVariants?.find(
        (variant) => parseInt(variant.inventoryLevel) > 0
    )

    if (product?.productName?.includes('Classic Leggings_Fresh Florals')) {
        console.log('product in NostoRecommendationProduct', product)
    }

    let variantId = firstVariantWithInventory?.id
    let variantUrl = `${productUrlBase}${productUrl}?variant=${variantId}`

    let productTags = product?.productTags

    let isOrganic = productTags ? !productTags.includes('no-gots') : false

    const formatPrice = (price) => {
        if (!price) return '$0.00'
        // Remove any currency symbols and commas, then parse as float
        const numericPrice = parseFloat(price.toString().replace(/[^0-9.]/g, ''))
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numericPrice)
    }

    const handleQuickBuy = () => {
        setQuickBuyActive(!quickBuyActive)
    }

    return (
        <div
            key={product.productId}
            className="nosto-recommendation-item flex flex-col"
        >
            <div
                ref={ref}
                className="relative w-full aspect-[2/3] bg-[#f8f8f8] overflow-hidden"
            >
                <a href={variantUrl}>
                    <img
                        src={product?.productImageUrl || product?.primaryImageUrl}
                        alt={parse(product?.productName || '')?.replace('_', ' - ')}
                        className="absolute inset-0 w-full h-full object-contain"
                    />
                </a>

                {isHovered ? (
                    <div className='quickview absolute bottom-[15%] left-1/2 transform -translate-x-1/2 hidden md:block'>
                        <button
                            className='quickview-button border border-ash text-ash bg-white uppercase text-sm h-[42px] px-4 min-w-[160px] tracking-wider'
                            onClick={handleQuickBuy}
                        >
                            Quick Buy
                        </button>
                    </div>
                ) : null}
            </div>
            <div className="mt-2 product-info">
                <div className="tag-buy-row flex items-center justify-between">
                    {isOrganic ? (
                        <OrganicTag />
                    ) : (
                        <span className="organic-tag-outer h-[24px] mt-1 inline-block">
                            &nbsp;
                        </span>
                    )}
                    <div
                        className="quickbuy-icon pr-1 cursor-pointer md:hidden"
                        data-balloon-pos="up-right"
                        aria-label="Quick Buy"
                        onClick={handleQuickBuy}
                    >
                        <QuickBuyBagIcon width="w-[16px]" />
                    </div>
                </div>
                <h3 className="text-sm font-medium min-h-[40px] mb-2">
                    <a href={variantUrl}>{parse(product?.productName || '')?.replace('_', ' - ')}</a>
                </h3>
                <p className="text-base">{formatPrice(product?.productPrice)}</p>
            </div>
            {quickBuyActive ? (
                <QuickBuyNosto
                    product={product}
                    quickBuyActive={quickBuyActive}
                    setQuickBuyActive={setQuickBuyActive}
                    variant={firstVariantWithInventory}
                    variants={productVariants}
                    variantId={variantId}
                    image={product?.productImageUrl || product?.primaryImageUrl}
                />
            ) : null}
        </div>
    )
}

export default NostoRecommendationProduct
